import { CruiseSuitePrice } from "types/api/suite_price";
import { isPresent } from "./checks";
import { removeDraft } from "./routing/pathsCache";

export const suiteSlugMappings: Record<string, Record<string, string>> = {
  "ship-silver-cloud-expedition": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    ME: "medallion-suite",
    DX: "deluxe-veranda-suite",
    VR: "veranda-suite",
    VI: "vista-suite"
  },
  "ship-silver-dawn": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    DX: "deluxe-veranda-suite",
    CV: "classic-veranda-suite",
    SV: "superior-veranda-suite",
    PA: "panorama-suite",
    VI: "vista-suite"
  },
  "ship-silver-explorer": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    SL: "silver-suite",
    ME: "medallion-suite",
    VR: "veranda-suite",
    VI: "vista-suite",
    VS: "view-suite",
    EC: "explorer-suite",
    AC: "adventurer-suite"
  },
  "ship-silver-moon": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    DX: "deluxe-veranda-suite",
    SV: "superior-veranda-suite",
    CV: "classic-veranda-suite",
    PA: "panorama-suite",
    VI: "vista-suite"
  },
  "ship-silver-muse": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    DX: "deluxe-veranda-suite",
    SV: "superior-veranda-suite",
    CV: "classic-veranda-suite",
    PA: "panorama-suite",
    VI: "vista-suite"
  },
  "ship-silver-origin": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    ME: "medallion-suite",
    DX: "deluxe-veranda-suite",
    SV: "superior-veranda-suite",
    CV: "classic-veranda-suite"
  },
  "ship-silver-shadow": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    ME: "medallion-suite",
    DX: "deluxe-veranda-suite",
    SV: "superior-veranda-suite",
    CV: "classic-veranda-suite",
    VI: "vista-suite"
  },
  "ship-silver-spirit": {
    O1: "owner-s-suite1",
    O2: "owner-s-suite1",
    G1: "grand-suite1",
    G2: "grand-suite1",
    R1: "royal-suite1",
    R2: "royal-suite1",
    SL: "silver-suite1",
    DX: "deluxe-veranda-suite",
    SV: "superior-veranda-suite",
    CV: "classic-veranda-suite",
    PA: "panorama-suite",
    VI: "vista-suite2"
  },
  "ship-silver-whisper": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    ME: "medallion-suite",
    DX: "deluxe-veranda-suite",
    SV: "superior-veranda-suite",
    CV: "classic-veranda-suite",
    VI: "vista-suite"
  },
  "ship-silver-wind": {
    O1: "owner-s-suite",
    O2: "owner-s-suite",
    G1: "grand-suite",
    G2: "grand-suite",
    R1: "royal-suite",
    R2: "royal-suite",
    SL: "silver-suite",
    ME: "medallion-suite",
    DX: "midship-veranda-suite",
    VR: "veranda-suite",
    VI: "vista-suite"
  }
};

export function getSuiteSlug(shipId: string, suiteCode: string): string {
  const realShipId = removeDraft(shipId);
  return (
    suiteSlugMappings[realShipId] && suiteSlugMappings[realShipId][suiteCode]
  );
}

export function priceForSuite(
  prices: CruiseSuitePrice[] | undefined,
  suiteCodes?: (string | undefined)[]
): CruiseSuitePrice | undefined {
  if (!prices || !suiteCodes) return undefined;

  const suitePrices = suiteCodes
    .map((suiteCode) => prices.find((p) => p.suiteCategory === suiteCode))
    .filter(isPresent);

  return (
    suitePrices.find((x) => x.priceFrom.type !== "waitlist") || suitePrices[0]
  );
}
